import {Component, Vue , Watch} from 'vue-property-decorator'
import {
    getOutputRecordInfoById,
    getOutputTemplateList,
    sendOutput, sendOutputRecord,
    setOutputTemplate, updateOutputRecord
} from "@/api/classManage";
import commonData from "@/utils/commonData"
import E from "wangeditor";
import {makeUploadSignature} from "@/utils/uploadMd5";

@Component({})
export default class AddProduce extends Vue {
    formModel = {
        templateId: '',
        title: '',
        content: '',
        recipient: '',
        secret: '',
        attachmentList: [], // 附件
        isFinish: '0', // 默认为否
        customerEmail: '', //收件人
        emailUser: '', //发件邮箱
        types: '0',
        isAutoSend: '0', // 默认为否
    }
    formRules = {
        title: [{required: true, message: '请填写邮件主题', trigger: ['blur', 'change']}],
        templateId: [{required: true, message: '请选择模板', trigger: ['change']}],
        content: [{required: true, message: '请填写正文', trigger: ['blur', 'change']}],
        souCourseName: [{required: true, message: '请选择项目名称', trigger: ['blur', 'change']}],
        attachmentList: [{required: true, message: '请上传附件', trigger: 'change'}],
        isFinish: [{required: true, message: '请选择是否同步项目服务完成', trigger: 'change'}],
        customerEmail: [{required: true, message: '请填写收件人邮箱', trigger: 'change'}],
        isAutoSend: [{required: true, message: '请选择是否回款后自动发放', trigger: 'change'}],
    }
    recordId = null //判断是否是编辑
    typeList = commonData.projectTypeArray
    // 开课时间
    isShow = null

    disabledBtn = false

    name = '' // 远程搜索name
    loading = false


    editor: any = null

    // templateList = [
    //     '模板一', '模板二', '模板三'
    // ]
    templatePage = 1
    templateLimit = 20
    classId = null
    financeOrderId = null
    outputTemplateList = [] // 模板列表
    dialogVisible = false
    isFinish = false
    dialogVisibletem = false
    timer = null
    fileCount = 0
    maxCount = 5
    total = 0
    signature = ''
    uploadData = {
        bucket: 'crm',
        signature: '' // 初始值为空，后续实时更新
    }
    typesClassName = 'requiredLabel'
    previewPath = ''
    previewName = ''
    previewVisible = false
    canSend = true
    isPrompt = false

    created() {
        //  新建
        this.financeOrderId = this.$route.query.financeOrderId ? String(this.$route.query.financeOrderId) : null
        this.classId = this.$route.query.classId ? String(this.$route.query.classId) : null
        this.formModel.customerEmail = this.$route.query.email ? String(this.$route.query.email) : ''
        this.isFinish = this.$route.query.isFinish == 'true' ? true : false;
        this.isPrompt = this.$route.query.isPrompt == 'true' ? true : false;
        if (this.isFinish == true) {
            this.formModel.isFinish = '0'
        }

        // 编辑
        this.recordId = this.$route.query.id
        if (!this.recordId) {
            this.getOutputTemplateList()
        } else {
            // 查详情
            this.getOutputRecordInfoById()
        }
    }

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    mounted() {
        this.initEditor()
    }

    beforeUpload (file) {
        // 1. 为当前文件实时生成专属 signature，并同步更新全局 uploadData
        const currentSignature = makeUploadSignature('crm', file.name);
        // this.uploadData.signature = currentSignature; // 同步更新，立即生效
        this.$set(this.uploadData, 'signature', currentSignature);
    }

    changeTemplateType(){
        this.outputTemplateList = []
        this.getOutputTemplateList()
    }

    /*初始化 默认家在论文模版*/
    getOutputTemplateList() {
        this.loading = true
        getOutputTemplateList({
            classesId: this.classId,
            financeOrderId: this.financeOrderId,
            types: this.formModel.types,
            page: String(this.templatePage),
            limit: String(this.templateLimit),
        }).then((res: any) => {
            this.outputTemplateList = res.outputTemplateList
            this.total = res.allNum
            if (this.outputTemplateList.length == 0) {
                this.dialogVisibletem = true
            }
            this.formModel.templateId = res.outputTemplateList[0].name
            /*默认模板1 ，可以更改*/
            this.formModel.recipient = res.outputTemplateList[0].ccStr
            this.formModel.secret = res.outputTemplateList[0].bccStr
            this.formModel.title = res.outputTemplateList[0].subjectStr
            this.formModel.emailUser = res.outputTemplateList[0].emailUser
            this.editor.txt.html(res.outputTemplateList[0].contentStr)
            this.formModel.customerEmail = res.customerEmail
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
    }

    handleSizeChange(val) {
        this.templateLimit = val;
        this.getOutputTemplateList()
    }

    handleCurrentChange(val) {
        this.templatePage = val;
        this.getOutputTemplateList()
    }

    // 初始化富文本编辑器
    initEditor() {
        //   console.log(E)
        this.editor = new E('#editor-box')
        this.editor.config.height = 200
        this.editor.config.excludeMenus = [
            'fontName',
            'table',
            'code',
            'todo',
            'video',
            'audio',
        ]
        // this.editor.config.uploadImgServer = 'http://192.168.1.71:10068/uploadFile'
        // this.editor.create()
        this.editor.config.uploadImgShowBase64 = true // 使用 base64 保存图片
        // 隐藏“网络图片”tab
        this.editor.config.showLinkImg = false
        // 创建编辑器
        this.editor.create()

        //      this.editor.txt.html()
    }

    /*邮箱校验规则*/
    validateEmail(email) {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return emailRegex.test(email);
    }

    // 保存
    doSave() {
        let flag = true;
        // this.formModel.content = this.editor.txt.html();
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
                return;
            }
        })
        /*  去掉空值*/
        if (this.formModel.recipient) {
            const emailarr = this.formModel.recipient.split(',')
            /*校验数组的每一项是否符合规则*/
            if (emailarr.some(item => !this.validateEmail(item))) {
                this.$message.error('抄送人邮箱格式不正确')
                flag = false
                return
            }
        }
        if (this.formModel.secret) {
            const emailarr1 = this.formModel.secret.split(',')
            if (emailarr1.some(item => !this.validateEmail(item))) {
                this.$message.error('密送人邮箱格式不正确')
                flag = false
                return
            }
        }

        // 如果获取到的模板，抄送或者密送是null，则转成空字符串
        this.formModel.recipient = this.formModel.recipient || ''
        this.formModel.secret = this.formModel.secret || ''

        if (this.formModel.customerEmail) {
            if (!this.validateEmail(this.formModel.customerEmail)) {
                this.$message.error('收件人邮箱格式不正确')
                flag = false
                return
            }
        }

        if (!this.editor.txt.html()) {
            this.$message.error('请填写正文')
            return
        }
        // 5. 附件列表处理与校验（核心逻辑：严格区分types规则）
        // 过滤空值，统一处理附件列表（空数组保护）
        this.formModel.attachmentList = (this.formModel.attachmentList || []).filter(item => item);
        // 核心规则：types=0 时附件必填，types=1 时可选
        if (this.formModel.types === '0') {
            if (this.formModel.attachmentList.length === 0) {
                this.$message.error('请上传附件');
                flag = false;
            }
        }
        // types=1 时不做必填校验，保留原有过滤逻辑即可
        if (!flag) {
            return
        } else {
            this.disabledBtn = true
        }

        const obj: any = {
            classesId: Number(this.classId),
            financeOrderId: Number(this.financeOrderId),
            subjectStr: this.formModel.title,
            contentStr: this.editor.txt.html(),
            ccStr: this.formModel.recipient,
            bccStr: this.formModel.secret,
            isFinish: this.formModel.isFinish,
            emailUser: this.formModel.emailUser,
            customerEmail: this.formModel.customerEmail,
            types: this.formModel.types,
            isAutoSend: this.formModel.isAutoSend,
        }
        if (this.formModel.attachmentList.length > 0) {
            obj.attachmentList = this.formModel.attachmentList.map(item => {
                return {
                    fileName: item.name,
                    filePath: item.url,
                }
            })
        }
        setOutputTemplate(obj).then((res: any) => {
            this.$message.success('保存成功')
            this.disabledBtn = false
            setTimeout(() => {
                window.close()
            }, 500)
        }).catch(() => {
            this.disabledBtn = false
        })
    }


    /*发送*/
    async doSaveAndSend() {
        const idList: any = [this.financeOrderId]
        /*保存*/
        // this.formModel.content = this.editor.txt.html();
        let flag = true;
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
                return;
            }
        })
        /*  去掉空值*/

        if (this.formModel.recipient) {
            const emailarr = this.formModel.recipient.split(',')
            /*校验数组的每一项是否符合规则*/
            if (emailarr.some(item => !this.validateEmail(item))) {
                this.$message.error('抄送人邮箱格式不正确')
                flag = false
                return
            }
        }
        if (this.formModel.secret) {
            const emailarr1 = this.formModel.secret.split(',')
            if (emailarr1.some(item => !this.validateEmail(item))) {
                this.$message.error('密送人邮箱格式不正确')
                flag = false
                return
            }
        }

        // 如果获取到的模板，抄送或者密送是null，则转成空字符串
        this.formModel.recipient = this.formModel.recipient || ''
        this.formModel.secret = this.formModel.secret || ''

        if (this.formModel.customerEmail) {
            if (!this.validateEmail(this.formModel.customerEmail)) {
                this.$message.error('收件人邮箱格式不正确')
                flag = false
                return
            }
        }

        if (!this.editor.txt.html()) {
            this.$message.error('请填写正文')
            return
        }
        // 5. 附件列表处理与校验（核心逻辑：严格区分types规则）
        // 过滤空值，统一处理附件列表（空数组保护）
        this.formModel.attachmentList = (this.formModel.attachmentList || []).filter(item => item);
        // 核心规则：types=0 时附件必填，types=1 时可选
        if (this.formModel.types === '0') {
            if (this.formModel.attachmentList.length === 0) {
                this.$message.error('请上传附件');
                flag = false;
            }
        }
        // types=1 时不做必填校验，保留原有过滤逻辑即可

        if (!flag) {
            return
        } else {
            this.disabledBtn = true
        }

        const obj: any = {
            classesId: Number(this.classId),
            financeOrderId: Number(this.financeOrderId),
            subjectStr: this.formModel.title,
            contentStr: this.editor.txt.html(),
            ccStr: this.formModel.recipient,
            bccStr: this.formModel.secret,
            isFinish: this.formModel.isFinish,
            emailUser: this.formModel.emailUser,
            customerEmail: this.formModel.customerEmail,
            types: this.formModel.types,
            isAutoSend: this.formModel.isAutoSend,
        }

        if (this.formModel.attachmentList.length > 0) {
            obj.attachmentList = this.formModel.attachmentList.map(item => {
                return {
                    fileName: item.name,
                    filePath: item.url,
                }
            })
        }
        await setOutputTemplate(obj).then(((res: any) => {
            const id = res.studentOutputId
            /*发送*/
            sendOutputRecord(String(id)).then((res: any) => {
                this.$message.success('发送成功')
                this.disabledBtn = false
                setTimeout(() => {
                    window.close()
                }, 500)
            }).catch(() => {
                this.disabledBtn = false
            })
        })).catch(err => {
            this.disabledBtn = false
        })

    }

    changeTemplate(val) {
        this.outputTemplateList.forEach((item, index) => {
            if (item.name == val) {
                this.formModel.recipient = this.outputTemplateList[index].ccStr
                this.formModel.secret = this.outputTemplateList[index].bccStr
                this.formModel.title = this.outputTemplateList[index].subjectStr
                this.editor.txt.html(this.outputTemplateList[index].contentStr)
                this.formModel.emailUser = item.emailUser
            }
        })
    }

    handleUploadSuccess(response, file, fileList) {
        if (fileList.every(item => item.status == 'success')) {
            this.formModel.attachmentList = fileList.map(item => {
                if (item.status == 'success') {
                    return {
                        name: item.name,
                        url: item.url ? item.url : item.response.data.ossUrl
                    }
                }
            });
            this.$message.success('上传成功')
            // 手动触发 Vue 更新
            this.$forceUpdate();
        }
    }

    handleUploadError() {
        this.$message.error('上传失败')
    }

    handleUploadRemove(file, fileList) {
        this.formModel.attachmentList = fileList
    }


    /*编辑相关*/

    // 详情
    getOutputRecordInfoById() {
        this.loading = true
        getOutputRecordInfoById(this.recordId).then((res: any) => {
            const data = JSON.parse(JSON.stringify(res.studentOutput))
            this.$set(this.formModel, 'secret', data.bccStr)
            this.$set(this.formModel, 'recipient', data.ccStr)
            this.$set(this.formModel, 'title', data.subjectStr)
            this.$set(this.formModel, 'emailUser', data.emailUser)
            this.$set(this.formModel, 'isFinish', data.isFinish)
            this.$set(this.formModel, 'customerEmail', data.customerEmail)
            this.$set(this.formModel, 'types', data.types)
            this.$set(this.formModel, 'isAutoSend', data.isAutoSend)
            this.editor.txt.html(data.contentStr)
            // this.$set(this.formModel, 'attachmentList', data.attachmentsList)
            this.formModel.attachmentList = data.attachmentsList.map(item => {
                return {
                    name: item.fileName,
                    url: item.filePath,
                }
            })
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
    }

    /*编辑保存*/
    doEditSave() {
        let flag = true;
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
                return;
            }
        })
        /*  去掉空值*/
        if (!this.editor.txt.html()) {
            this.$message.error('请填写正文')
            return
        }
        // 5. 附件列表处理与校验（核心逻辑：严格区分types规则）
        // 过滤空值，统一处理附件列表（空数组保护）
        this.formModel.attachmentList = (this.formModel.attachmentList || []).filter(item => item);
        // 核心规则：types=0 时附件必填，types=1 时可选
        if (this.formModel.types === '0') {
            if (this.formModel.attachmentList.length === 0) {
                this.$message.error('请上传附件');
                flag = false;
            }
        }
        // types=1 时不做必填校验，保留原有过滤逻辑即可
        if (this.formModel.recipient) {
            const emailarr = this.formModel.recipient.split(',')
            /*校验数组的每一项是否符合规则*/
            if (emailarr.some(item => !this.validateEmail(item))) {
                this.$message.error('抄送人邮箱格式不正确')
                flag = false
                return
            }
        }
        if (this.formModel.secret) {
            const emailarr1 = this.formModel.secret.split(',')
            if (emailarr1.some(item => !this.validateEmail(item))) {
                this.$message.error('密送人邮箱格式不正确')
                flag = false
                return
            }
        }

        if (this.formModel.customerEmail) {
            if (!this.validateEmail(this.formModel.customerEmail)) {
                this.$message.error('收件人邮箱格式不正确')
                flag = false
                return
            }
        }

        if (!flag) {
            return
        } else {
            this.disabledBtn = true
        }
        const obj: any = {
            subjectStr: this.formModel.title,
            contentStr: this.editor.txt.html(),
            ccStr: this.formModel.recipient,
            bccStr: this.formModel.secret,
            isFinish: this.formModel.isFinish,
            customerEmail: this.formModel.customerEmail,
            isAutoSend: this.formModel.isAutoSend,
        }

        if (this.formModel.attachmentList.length > 0) {
            obj.attachmentList = this.formModel.attachmentList.map(item => {
                return {
                    fileName: item.name,
                    filePath: item.url,
                }
            })
        }
        updateOutputRecord(this.recordId, obj).then((res: any) => {
            this.$message.success('编辑保存成功')
            setTimeout(() => {
                window.close()
            }, 500)
        })
    }

    async doEditSaveAndSend() {

        let flag = true;
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
                return;
            }
        })
        /*  去掉空值*/
        if (!this.editor.txt.html()) {
            this.$message.error('请填写正文')
            return
        }
        // 5. 附件列表处理与校验（核心逻辑：严格区分types规则）
        // 过滤空值，统一处理附件列表（空数组保护）
        this.formModel.attachmentList = (this.formModel.attachmentList || []).filter(item => item);
        // 核心规则：types=0 时附件必填，types=1 时可选
        if (this.formModel.types === '0') {
            if (this.formModel.attachmentList.length === 0) {
                this.$message.error('请上传附件');
                flag = false;
            }
        }
        // types=1 时不做必填校验，保留原有过滤逻辑即可
        if (this.formModel.recipient) {
            const emailarr = this.formModel.recipient.split(',')
            /*校验数组的每一项是否符合规则*/
            if (emailarr.some(item => !this.validateEmail(item))) {
                this.$message.error('抄送人邮箱格式不正确')
                flag = false
                return
            }
        }
        if (this.formModel.secret) {
            const emailarr1 = this.formModel.secret.split(',')
            if (emailarr1.some(item => !this.validateEmail(item))) {
                this.$message.error('密送人邮箱格式不正确')
                flag = false
                return
            }
        }
        if (this.formModel.customerEmail) {
            if (!this.validateEmail(this.formModel.customerEmail)) {
                this.$message.error('收件人邮箱格式不正确')
                flag = false
                return
            }
        }

        if (!flag) {
            return
        } else {
            this.disabledBtn = true
        }
        const obj: any = {
            subjectStr: this.formModel.title,
            contentStr: this.editor.txt.html(),
            ccStr: this.formModel.recipient,
            bccStr: this.formModel.secret,
            isFinish: this.formModel.isFinish,
            customerEmail: this.formModel.customerEmail,
            isAutoSend: this.formModel.isAutoSend,
        }
        if (this.formModel.attachmentList.length > 0) {
            obj.attachmentList = this.formModel.attachmentList.map(item => {
                return {
                    fileName: item.name,
                    filePath: item.url,
                }
            })
        }
        /*编辑保存*/
        await updateOutputRecord(this.recordId, obj).catch(err => {
            this.disabledBtn = false
        })
        /*编辑发送*/
        await sendOutputRecord(this.recordId).then((res: any) => {
            this.$message({
                message: '发送成功',
                type: 'success'
            })
            setTimeout(() => {
                window.close()
            }, 500)
        }).catch(err => {
            this.disabledBtn = false
        })
    }

    // 新建编辑去发送
    oepnEditproduce() {
        this.dialogVisible = true
    }

    confirmSendProduce() {
        if (this.recordId) {
            this.doEditSaveAndSend()
            this.dialogVisible = false
        } else {
            this.doSaveAndSend()
            this.dialogVisible = false
        }
    }

    doCancel() {
        this.dialogVisibletem = false
        /*关闭当前页面*/
        setTimeout(() => {
            window.close()
        }, 500)
    }

    doConfirm() {
        this.dialogVisibletem = false
        /*打开新建产出模板*/
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/ProduceMouldAdd?produceTypes='+ this.formModel.types, "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                clearInterval(time)
            }
        }, 500)
    }

    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }


/*
* 监听types 根据选中值修改classname*/
    @Watch('formModel.types')
    handleTypes(val: string){
        if( val === '0'){
            this.typesClassName = 'requiredLabel'
        }else{
            this.typesClassName = ''
        }

    }
//    监听isAutoSend变化
    @Watch('formModel.isAutoSend')
    handleIsAutoSend(val: string){
        if (val === '1') {
            this.canSend = false
        } else {
            this.canSend = true
        }
    }
}
